import React, {useEffect, useState} from "react";
import Grid from "@material-ui/core/Grid";
import {Box, Tab, Tabs} from "@material-ui/core";
import {TabPanel} from "@material-ui/lab";
import Typography from "@material-ui/core/Typography";
import PropTypes from "prop-types";
import SystemConfig from './SystemConfiguration';
import ListUsers from './ListUsers';

export default function FmapConfiguration() {
    const [value, setValue] = useState(0);

    const handleChange = (event, newValue) => {
        setValue(newValue);
    };
    function TabPanel(props) {
        const { children, value, index, ...other } = props;

        return (
            <div
                role="tabpanel"
                hidden={value !== index}
                id={`simple-tabpanel-${index}`}
                aria-labelledby={`simple-tab-${index}`}
                {...other}
            >
                {value === index && (
                    <Box sx={{ p: 3 }}>
                        <Typography>{children}</Typography>
                    </Box>
                )}
            </div>
        );
    }

    TabPanel.propTypes = {
        children: PropTypes.node,
        index: PropTypes.number.isRequired,
        value: PropTypes.number.isRequired,
    };

    function a11yProps(number) {
        return [];
    }

    return (
        <Box sx={{ width: '100%' }}>
            <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
                <Tabs value={value} onChange={handleChange} aria-label="basic tabs example">
                    <Tab label="System Configuration" {...a11yProps(0)} />
                </Tabs>
            </Box>
            <TabPanel value={value} index={0}>
            <SystemConfig title="" subTitle="" questionnaireTitle="" questions={[]}/>
            </TabPanel>
        </Box>
    );
}
